var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Star/Filled/14x14 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 14 0 14 13.3721206 0 13.3721206"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Star/Filled/14x14",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(-0.000000, 0.300000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66913604,10.9655846 L3.36354783,13.2660351 C2.91246163,13.5798342 2.31873948,13.1483604 2.47786771,12.6223904 L3.64436236,8.76765374 C3.71434313,8.53587032 3.63277319,8.28492019 3.43976892,8.1382726 L0.230459975,5.70543812 C-0.207254106,5.37336379 0.0191804699,4.6753391 0.568328889,4.66419567 L4.59512014,4.58217999 C4.83715552,4.57727688 5.05110945,4.42216028 5.1304507,4.19305128 L6.45295343,0.389128709 C6.63303132,-0.12970957 7.36716074,-0.12970957 7.54723863,0.389128709 L8.86974136,4.19305128 C8.94908261,4.42216028 9.1625908,4.57727688 9.40507192,4.58217999 L13.4314174,4.66419567 C13.9805659,4.6753391 14.2074462,5.37336379 13.7697321,5.70543812 L10.5604231,8.1382726 C10.3674189,8.28492019 10.2858489,8.53587032 10.3558297,8.76765374 L11.5223243,12.6223904 C11.6814526,13.1483604 11.0877304,13.5798342 10.6366442,13.2660351 L7.33105601,10.9655846 C7.13225715,10.8269603 6.8679349,10.8269603 6.66913604,10.9655846",
    id: "Fill-6",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fce712dc4d5bbc62699c3933ab506ccf.svg";
export { ForwardRef as ReactComponent };